import React from 'react';
import ReactDOM from 'react-dom';
import { Translation } from 'react-i18next/src';
import Dialog from '@hobs/components/Dialog';
import { RaisedButton, GhostButton } from '@hobs/components/Buttons';
import Styles from './Confirm.module.scss';

class ConfirmContainer extends React.Component {
  state = {
    title: null,
    message: null,
    resolveCallback: () => {},
    rejectCallback: () => {},
    yesButtonTitle: null,
    noButtonTitle: null,
    onCloseCallback: () => {}
  };

  constructor(props) {
    super(props);
    this.show = this.show.bind(this);
    this.handleYes = this.handleYes.bind(this);
    this.handleNo = this.handleNo.bind(this);
    this.resetState = this.resetState.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  static create() {
    const containerElement = document.createElement('div');
    document.body.appendChild(containerElement);
    const cc = ReactDOM.render(<ConfirmContainer />, containerElement);
    if (cc === null) {
      throw new Error('ConfirmContainer is null');
    }
    return cc;
  }

  show(
    title,
    message,
    resolveCallback,
    rejectCallback,
    yesButtonTitle = null,
    noButtonTitle = null,
    onCloseCallback,
  ) {
    this.setState({
      title,
      message,
      resolveCallback,
      rejectCallback,
      yesButtonTitle,
      noButtonTitle,
      onCloseCallback
    });
  }

  handleYes() {
    if (
      this.state.resolveCallback &&
      typeof this.state.resolveCallback === 'function'
    ) {
      this.state.resolveCallback();
    }
    this.resetState();
  }

  handleNo() {
    if (
      this.state.rejectCallback &&
      typeof this.state.rejectCallback === 'function'
    ) {
      this.state.rejectCallback();
    }
    this.resetState();
  }

  handleClose() {
    if (
      this.state.onCloseCallback &&
      typeof this.state.onCloseCallback === 'function'
    ) {
      this.state.onCloseCallback();
    }
    else if (
      this.state.rejectCallback &&
      typeof this.state.rejectCallback === 'function'
    ) {
      this.state.rejectCallback();
    }

    this.resetState();
  }

  resetState() {
    this.setState({
      title: null,
      message: null,
      resolveCallback: () => {},
      rejectCallback: () => {},
      yesButtonTitle: null,
      noButtonTitle: null,
      onCloseCallback: () => {}
    });
  }

  render() {
    return <div>{this.renderConfirm()}</div>;
  }

  renderConfirm() {
    if (!this.state.title && !this.state.message) {
      return null;
    }
    return (
      <Dialog
        title={this.state.title}
        isOpen={true}
        onClose={this.handleClose}
        className={Styles.confirm}
      >
        <div className={Styles['message']}>
          {<Translation>{t => t(this.state.message)}</Translation>}
        </div>

        <div className={Styles['inline-buttons']}>
          <GhostButton onClick={this.handleNo}>
            {this.state.noButtonTitle ? (
              this.state.noButtonTitle
            ) : (
              <Translation>{t => t('No')}</Translation>
            )}
          </GhostButton>
          <RaisedButton onClick={this.handleYes}>
            {this.state.yesButtonTitle ? (
              this.state.yesButtonTitle
            ) : (
              <Translation>{t => t('Yes')}</Translation>
            )}
          </RaisedButton>
        </div>
      </Dialog>
    );
  }
}

const confirm = ConfirmContainer.create();

export default confirm.show;
